export default {
  //Used in search bar, user details, etc. -------------------------------
  transfer: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper:
      "absolute left-5 flex items-center pointer-events-none text-primary",
    input:
      "w-full h-[40px] md:h-[44px] lg:h-[46px] rounded-full text-sm md:text-base text-text placeholder-text_secondary bg-canvas focus:bg-canvas border border-bordered px-4 py-2 focus:outline-none focus:ring-1 focus:ring-primary focus:border-none",
    input_with_icon: "pl-14",
    textarea:
      "w-full focus:transparent placeholder-text_secondary border border-none rounded-md focus:outline-none focus:ring-1 focus:border-none",
  },

  transfer_compact: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "w-full h-[38px] rounded-full text-sm text-text placeholder-text_secondary bg-canvas px-4 py-2 focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-none",
    input_with_icon: "pl-12",
    textarea: "w-full rounded-xl text-sm text-text placeholder-text_secondary/80 bg-neutral focus:bg-neutral px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-none",
  },

  // Standard help-center form input (used on /help-center/submit-request)
  hc_standard: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "w-full h-[59px] rounded-full text-base text-text placeholder-text_secondary bg-neutral border border-bordered pl-7 pr-4 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary",
    input_with_icon: "pl-14",
    textarea: "w-full rounded-[30px] text-base text-text placeholder-text_secondary bg-neutral border border-bordered px-7 py-4 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary",
  },

}
